import { render } from "./BomValidationResults.vue?vue&type=template&id=652148e0"
import script from "./BomValidationResults.vue?vue&type=script&lang=js"
export * from "./BomValidationResults.vue?vue&type=script&lang=js"

import "./BomValidationResults.vue?vue&type=style&index=0&id=652148e0&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__